/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { url } from 'utils/urls';
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/reward/giftcard/giftcard_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ REWARD : GIFTCARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const GiftCard = (props) => {
	const handleClick = (e) => {
    // This functionality is deprecated
		// trackEvent({ type: 'click', name: 'giftCardSelected', props, additionalProps: {type: props.type, target: url.b2cURL, rewardAvailable: props.rewardAvailable, numOfRewards: props.numOfRewards}});
        refreshAds();
		if (props.processClick) {
			if(!!props.rewardAvailable) {
	            props.processClick();
			} else {
				e.preventDefault();
				window.open(url.b2cURL);
			}
		}
	};
	return (
        <div className={`giftcard ${sheet.classes.giftcard} ${props.type} rewardAvailable-${!!props.rewardAvailable}`} onClick={handleClick} />
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GiftCard;
